module.exports = __webpack_public_path__ + "static/media/instagram.675fa0ab.svg";